export default __webpack_public_path__ + "static/media/zoomOUT.d0c955b7.svg";